import React from 'react';

const About = () => {
    return (
        <div>
          <h1>abouts</h1>
        </div>
    );
};

export default About;